import * as types from '../actions/actionTypes';

const initialState = {
  attachedToLine: [],
  waterfallSectionsData: [],
  underlaymentSections: [],

  selectedFeature: null,
  selectedPartIds: [],
  resourceTypes: []
};

export default function(state = {...initialState}, action) {
  let filteredResource;
  let resourceTypes;
  let newState;
  switch(action.type) {
    case types.SET_SELECTED_FEATURE:
    case types.SET_SELECTED_PART_IDS:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_RESOURCES:
      state = {...state, [action.payload.resourceType]: action.payload.resources};
      break;
    case types.ADD_RESOURCE:
      newState = {
        [action.payload.resourceType]: [...state[action.payload.resourceType], action.payload.resource],
      }
      if (!state.resourceTypes.includes(action.payload.resourceType)) {
        newState.resourceTypes = [...state.resourceTypes, action.payload.resourceType]
      }
      return Object.assign({}, state, newState);
    case types.CHANGE_RESOURCE:
      filteredResource = state[action.payload.resourceType].map((item) => {
        if (item.id !== action.payload.resource.id) { return item }

        return {
          ...item,
          ...action.payload.resource
        }
      })

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });

    case types.DELETE_RESOURCE:
      filteredResource = state[action.payload.resourceType].filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });
    case types.DELETE_RESOURCE_ATTACHED_TO:
      filteredResource = state[action.payload.resourceType].filter((row) => row.attachedToId !== action.payload.attachedTo.id);

      return Object.assign({}, state, {[action.payload.resourceType]: filteredResource });
    case types.DELETE_ALL_RESOURCES:
      resourceTypes = {}
      for (const resourceType of state.resourceTypes) {
        resourceTypes[resourceType] = [];
      }
      return Object.assign({}, state, resourceTypes);
  }

  return state;
}
